import { Factory } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  products: () => [
    {
      'subscription-plan-id': 'visitors-premium-monthly-calendar-billing',
      quantity: faker.number.int(20),
    },
    {
      'subscription-plan-id': 'deliveries-standard-monthly-calendar-billing',
      quantity: faker.number.int(20),
    },
    {
      'subscription-plan-id': 'rooms-standard-monthly-calendar-billing',
      quantity: faker.number.int(20),
    },
  ],
});
